import React from 'react'
import Breadcrumb from '../Breadcrumb'

const PrivacyPolicy = () => {
    return (
        <>
            {/* <div className="site-breadcrumb">
                <div className="container">
                    <h2 className="breadcrumb-title">Privacy Policy</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li className="active">Privacy Policy</li>
                    </ul>
                </div>
                <div className="hero-shape">
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
                </div>
            </div> */}
            <Breadcrumb
        title="Privacy Policy"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Privacy Policy", active: true }
        ]}
      />


            {/* Privacy Policy Section */}
            <div className="policy-area py-120 mb-30 position-relative d-block">
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className="col-lg-6" style={{paddingRight:'30px'}}  >
                            <div className="left-sec-policy position-relative mt-0 mr-4 mb-2 ml-2">
                            <div className="position-absolute rounded-circle bg-light" style={{width: '200px',height: '200px',background: '#ecf0fe',left: '-50px',top: '-50px',zIndex: -1,}}></div>
                                <div className="policy-img ">
                                    <img 
                                    loading="lazy"
                                    role="presentation"
                                    decoding="async"
                                    fetchpriority="high"src="https://symptai.com/assets/main/85c3e1_15629a69bb4b4b36b67a36d6ee21b66c~mv2-(1).webp" style={{borderRadius:'15px'}} alt="" />
                                </div>
                                <div className="policy-shape position-absolute z-n1" style={{right:'-20px',bottom:'-20px'}}>
                                    <img 
                                    loading="lazy"
                                    role="presentation"
                                    decoding="async"
                                    fetchpriority="high"src="./assets/img/shape/01.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-sec-policy position-relative d-block">
                                <div className="site-heading mb-3">
                                    <span className='site-title-tagline'>Introduction</span>
                                </div>
                                <div className='policy-intro-text'>
                                    <p>
                                    Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you visit our Skilletix job portal. We are committed to safeguarding your data and ensuring a secure job search experience.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div className='content container mt-60'>
                    <div className='row align-items-center'>
                        <div className='infocollection mb-60'>
                            <span className='site-title-tagline'>Information we Collect</span>
                            <div className='detailed-text mt-20'>
                                <p>
                                We collect personal information such as your name, email address, phone number, resume details, job preferences, and work experience when you create an account or apply for jobs. 
                                </p>
                            </div>
                        </div>


                        <div className='useofinfo mb-60'>
                            <span className='site-title-tagline'>How We Use Your Information</span>
                            <div className='detailed-text mt-20'>
                                <p>
                                We use your information to:
                                    <ul className="ps-3">
                                        <li>Match job seekers with relevant job opportunities based on their profile and preferences.</li>
                                        <li>Facilitate job applications and employer communication.</li>
                                        <li>Send job alerts, newsletters, and career advice.</li>
                                        <li>Improve our job portal services and user experience.</li>
                                        <li>Ensure compliance with legal and regulatory requirements.</li>
                                    </ul>
                                </p>
                            </div>
                        </div>


                        <div className='shareinfo mb-60'>
                            <span className='site-title-tagline'>Sharing Your Information</span>
                            <div className='detailed-text mt-20'>
                                <p>
                                Your information may be shared with potential employers when you apply for a job. We do not sell your personal data but may share it with trusted third-party service providers for job-matching purposes, background verification, or career enhancement services.
                                </p>
                            </div>
                        </div>



                        <div className='datasec mb-60'>
                            <span className='site-title-tagline'>Data Storage and Security</span>
                            <div className='detailed-text mt-20'>
                                <p>
                                We take appropriate security measures to protect your information from unauthorized access, alteration, or disclosure. Your profile and resume data are stored securely, and you have control over its visibility to employers.
                                </p>
                            </div>
                        </div>




                        <div className='cookies mb-60'>
                            <span className='site-title-tagline'>Cookies and Tracking Technologies</span>
                            <div className='detailed-text mt-20'>
                                <p>
                                    <ul>
                                <li>Some of our web pages utilize "cookies" and other tracking technologies. A "cookie" is a small text file that may be used, for example, to collect information about web-site activity. Some cookies and other technologies may serve to recall Personal Information previously indicated by a user. Most browsers allow you to control cookies, including whether or not to accept them and how to remove them.</li>
                                <li>You may set most browsers to notify you if you receive a cookie, or you may choose to block cookies with your browser, but please note that if you choose to erase or block your cookies, you will need to re-enter your original user ID and password to gain access to certain parts of the Platform.</li>
                                <li>Tracking technologies may record information such as Internet domain and host names; Internet protocol (IP) addresses; browser software and operating system types; clickstream patterns; and dates and times that our site is accessed. Our use of cookies and other tracking technologies allows us to improve our Platform and the overall website experience. We may also analyse information that does not contain Personal Information for trends and statistics. </li>
                                <li>Our job portal uses cookies to personalize your experience, remember your preferences, and track usage patterns. You can manage or disable cookies through your browser settings.</li>
                                </ul>
                                </p>
                            </div>
                        </div>




                        <div className='law mb-60'>
                            <span className='site-title-tagline'>Governing Law</span>
                            <div className='detailed-text mt-20'>
                                <p>
                                This Privacy Policy is governed by the laws of India. Any disputes arising from this policy shall be resolved in the courts of Gurugram, Haryana.
                                </p>
                            </div>
                        </div>




                        <div className='contactus'>
                            <span className='site-title-tagline mb-20'>Contact Us</span>
                            <div className='detailed-text mt-20'>
                                <div className='contacting-info'>
                                    <ul className="footer-contact">
                                        <li>
                                            <a href="tel:+21236547898">
                                                <i className="far fa-phone" />
                                                +9195991 71535
                                            </a>
                                        </li>
                                        <li>
                                            <i className="far fa-map-marker-alt" />
                                            Gurugram, Haryana 122505
                                        </li>
                                        <li>
                                            <a href="mailto:info@hashedbitinnovations.com">
                                                <i className="far fa-envelope" />
                                                <span
                                                    className="__cf_email__"
                                                >hashedbitinnovations.com
                                                </span>
                                            </a>
                                        </li>
                                    </ul>

                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy